import TagManager from "react-gtm-module";
import config from "./config";

export class GTM {
    initialize() {
        const env = config.REACT_APP_ENV;

        const tagManagerArgs = {
            gtmId: "",
            auth: "",
            preview: "",
        };
        if (env === "prod") {
            //production
            tagManagerArgs.gtmId = config.REACT_GTM_ID;
            tagManagerArgs.auth = config.REACT_GTM_AUTH;
            tagManagerArgs.preview = config.REACT_GTM_PREVIEW;
        }
        if (env === "staging") {
            //ACPT
            tagManagerArgs.gtmId = config.REACT_GTM_ID;
            tagManagerArgs.auth = config.REACT_GTM_AUTH;
            tagManagerArgs.preview = config.REACT_GTM_PREVIEW;
        }
        if (env === "itest") {
            //dev
            tagManagerArgs.gtmId = config.REACT_GTM_ID;
            tagManagerArgs.auth = config.REACT_GTM_AUTH;
            tagManagerArgs.preview = config.REACT_GTM_PREVIEW;
        }

        TagManager.initialize(tagManagerArgs);
    }

    PageView(
        title,
        employer,
        userId,
        userRole,
        path,
        page_referrer,
        page_referrer_title,
        employeeId,
        userEmail,
        relatedOrgs,
        organizationId,
        reportsEnabled,
    ) {
        const dataLayer = {
            event: "custom_pageview",
            env: config.REACT_APP_ENV,
            page_title: title,
            app_source: "web",
            journey_name: "admin",
            digital_asset: "unum insights",
            page_location: path,
            page_referrer: page_referrer,
            page_referrer_title: page_referrer_title,
            user_id: userId,
            user_type: userRole,
            email: userEmail,
            related_orgs: relatedOrgs,
            organization_id: organizationId,
            reports_enabled: reportsEnabled,
        };
        if (employeeId)
            dataLayer.employer_id = employeeId;
        if (employer)
            dataLayer.employer = employer;
        TagManager.dataLayer({ dataLayer: dataLayer });
    }

    Event(
        page,
        category,
        action,
        label,
        attribute1,
        attribute2,
        attribute3,
        attribute4,
        reporting_period,
        coverage_type,
        payment_status,
        policies_and_divisions,
        reporting_group,
        include_historical_leave,
        period_schedule_type,
        compare_your_company_to
    ) {
        const dataLayer = {
            event: "custom_event",
            page: page,
            category: category,
            action: action,
            label: label,
            attribute1: attribute1,
            attribute2: attribute2,
            attribute3: attribute3,
            attribute4: attribute4,
        };
        if (reporting_period) dataLayer.reporting_period = reporting_period;
        if (coverage_type) dataLayer.coverage_type = coverage_type;
        if (payment_status) dataLayer.payment_status = payment_status;
        if (policies_and_divisions)
            dataLayer.policies_and_divisions = policies_and_divisions;
        if (reporting_group) dataLayer.reporting_group = reporting_group;
        if (include_historical_leave)
            dataLayer.include_historical_leave = include_historical_leave;
        if (period_schedule_type)
            dataLayer.period_schedule_type = period_schedule_type;
        if (compare_your_company_to) dataLayer.compare_your_company_to = compare_your_company_to;
        TagManager.dataLayer({
            dataLayer: dataLayer,
        });
    }
}

export default GTM;
